webpackJsonp([2],{

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("ET/6");


/***/ }),

/***/ "ET/6":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var xhr = null,
    resetTimeout = false,
    minLength = 3;

var $el_searchForm = $('form#searchForm'),
    $el_search = $el_searchForm.find('input#search_form_search'),
    $el_token = $el_searchForm.find("input[name='token']"),
    $el_results = $('div.search-results'),
    $el_details = $('div.resultDataDetails'),
    searchLoading = $('#search-loading');

function search() {
    var keyword = $el_search.val();

    if (keyword.length < minLength) {
        return false;
    }
    if (resetTimeout != false) {
        clearTimeout(resetTimeout);
    }

    resetTimeout = setTimeout(function () {
        if (xhr) {
            xhr.abort();
        }
        $el_results.html(searchLoading.clone());
        xhr = $.post(appPath.resultSearch, {
            keyword: keyword,
            token: $el_token.val()
        }, function (result) {
            displaySearchResults(result);
        });
    }, 250);
}

function displayDrugInformation(din) {
    if (xhr) {
        xhr.abort();
    }

    $el_details.html(searchLoading.clone());
    xhr = $.post(appPath.details, {
        din: din,
        token: $el_token.val()
    }, function (result) {
        $el_details.html(result);
        setButtonsDetails();
    });
}

function setButtonsDetails() {
    $el_details.find('.btnProduitClasse, .btnProduitSimilaire, .btnDiag').click(function () {
        if (xhr) xhr.abort();
        $el_search.val('');
        $el_results.html(searchLoading.clone());
    });

    $el_details.find('.btnProduitClasse').click(function () {
        xhr = $.post(appPath.search_class, {
            class: $(this).data('class'),
            token: $el_token.val()
        }, function (result) {
            displaySearchResults(result);
        });
    });
    $el_details.find('.btnProduitSimilaire').click(function () {
        xhr = $.post(appPath.search_produit_similaire, {
            din: $(this).data('din'),
            token: $el_token.val()
        }, function (result) {
            displaySearchResults(result);
        });
    });
    $el_details.find('.btnDiag').click(function () {
        xhr = $.post(appPath.search_diag_similaire, {
            din: $(this).data('din'),
            token: $el_token.val()
        }, function (result) {
            displaySearchResults(result);
        });
    });
}

function displaySearchResults(html) {
    $el_results.html(html);
    $el_results.find('li').on('click', function () {
        var $el_li = $(this);
        $el_results.find('li').removeClass('selected');
        $el_li.addClass('selected');
        displayDrugInformation($el_li.data('din'));
    });
}

$(function () {

    var elem_body = $('body');
    var windowWidth = window.innerWidth;
    setWindowWidth();

    $(elem_body).tooltip({
        selector: '[data-toggle="tooltip"]'
    });

    /**
     * Ajoute une classe CSS sur l'élément body en fonction de la taille d'écran
     * @param windowWidth
     */
    function setWindowWidth(windowWidth) {
        if (window.innerWidth <= 812) {
            $(elem_body).removeClass('screen-lg screen-md').addClass('screen-sm');
        } else if (window.innerWidth > 812 && window.innerWidth < 1199) {
            $(elem_body).removeClass('screen-lg screen-sm').addClass('screen-md');
        } else {
            $(elem_body).removeClass('screen-md screen-sm').addClass('screen-lg');
        }
    }

    $(window).resize(function () {
        setWindowWidth(window.innerWidth);
    });

    $el_searchForm.submit(function (e) {
        e.preventDefault();
        search();
    });

    $el_search.keyup(function (e) {
        search();
    });

    $('#btnDownload').click(function () {
        window.open(appPath.generateRapport, '_blank');
    });

    $('.all-med-link').on('click', function (e) {
        e.preventDefault();
        window.location.href = appPath.generate_pdf + '?token=' + $el_token.val();
    });

    /**
     * Lors du focus du champ de recherche, l'interface est scrollé dans la vue
     */
    $('#search_form_search').on('focus', function () {
        if ($(elem_body).hasClass('screen-sm')) {
            $('html, body').animate({
                scrollTop: $(this).offset().top - 100
            }, 300);
        }
        return false;
    });

    /**
     * Clic sur les boutons de recherche de produits similaire scroll la recherche dans la vue
     */
    $(elem_body).on('click', '.btnProduitSimilaire, .btnProduitClasse, .btnDiag', function () {
        if ($(elem_body).hasClass('screen-sm')) {
            $('html, body').animate({
                scrollTop: $('#search_form_search').offset().top - 100
            }, 300);
        }
        return false;
    });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("7t+N")))

/***/ })

},[1]);


// WEBPACK FOOTER //
// app/js.js